module.exports = __webpack_public_path__ + "img/icon-triangle.275f9da.svg";